import { SVGProps } from "react";

export default function CodeBlockIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 13, width = 12, stroke = "#292D32", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M4.49781 7C4.16781 7.165 3.89281 7.41 3.68781 7.715C3.57281 7.89 3.57281 8.11 3.68781 8.285C3.89281 8.59 4.16781 8.835 4.49781 9"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.60156 7C7.93156 7.165 8.20656 7.41 8.41156 7.715C8.52656 7.89 8.52656 8.11 8.41156 8.285C8.20656 8.59 7.93156 8.835 7.60156 9"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 11.5H7.5C10 11.5 11 10.5 11 8V5C11 2.5 10 1.5 7.5 1.5H4.5C2 1.5 1 2.5 1 5V8C1 10.5 2 11.5 4.5 11.5Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.11719 4.505L10.7272 4.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
